import { render, staticRenderFns } from "./DetailTask.vue?vue&type=template&id=005531d0&scoped=true"
import script from "./DetailTask.vue?vue&type=script&lang=js"
export * from "./DetailTask.vue?vue&type=script&lang=js"
import style0 from "./DetailTask.vue?vue&type=style&index=0&id=005531d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005531d0",
  null
  
)

export default component.exports